/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InstagramConnectionResponse } from '../../models/instagram-connection-response';
import { InstagramConnectRequest } from '../../models/instagram-connect-request';

export interface ConnectInstagramAccount$Params {
      body: InstagramConnectRequest
}

export function connectInstagramAccount(http: HttpClient, rootUrl: string, params: ConnectInstagramAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<InstagramConnectionResponse>> {
  const rb = new RequestBuilder(rootUrl, connectInstagramAccount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InstagramConnectionResponse>;
    })
  );
}

connectInstagramAccount.PATH = '/v1/api/ui/instagram-accounts/connect';
